export default __webpack_public_path__ + "static/media/xero.2a54307b.png";